// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ComputerScreenIconSignature {
  Element: SVGSVGElement;
}

export const ComputerScreenIcon: TOC<ComputerScreenIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 3H2C0.897 3 0 3.896 0 5V18C0 19.103 0.897 20 2 20H11V22H7V24H17V22H13V20H22C23.103 20 24 19.103 24 18V5C24 3.896 23.103 3 22 3ZM22 5L21.998 15H2V5H22ZM2 17V18H21.997V17H2Z"/>
</svg>
</template>;